module.exports = __webpack_public_path__ + "img/BZ.22e446da.png";